module.exports = __webpack_public_path__ + "tv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tv.svg
// module id = 1111
// module chunks = 0